// import React, {useContext} from "react";
// import "./Achievement.scss";
// import AchievementCard from "../../components/achievementCard/AchievementCard";
// import {achievementSection} from "../../portfolio";
// import {Fade} from "react-reveal";
// import StyleContext from "../../contexts/StyleContext";
// export default function Achievement() {
//   const {isDark} = useContext(StyleContext);
//   if (!achievementSection.display) {
//     return null;
//   }
//   return (
//     <Fade bottom duration={1000} distance="20px">
//       <div className="main" id="achievements">
//         <div className="achievement-main-div">
//           <div className="achievement-header">
//             <h1
//               className={
//                 isDark
//                   ? "dark-mode heading achievement-heading"
//                   : "heading achievement-heading"
//               }
//             >
//               {achievementSection.title}
//             </h1>
//             <p
//               className={
//                 isDark
//                   ? "dark-mode subTitle achievement-subtitle"
//                   : "subTitle achievement-subtitle"
//               }
//             >
//               {achievementSection.subtitle}
//             </p>
//           </div>
//           <div className="achievement-cards-div">
//             {achievementSection.achievementsCards.map((card, i) => {
//               return (
//                 <AchievementCard
//                   key={i}
//                   isDark={isDark}
//                   cardInfo={{
//                     title: card.title,
//                     description: card.subtitle,
//                     image: card.image,
//                     imageAlt: card.imageAlt,
//                     footer: card.footerLink
//                   }}
//                 />
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </Fade>
//   );
// }

import React, {useContext} from "react";
import "./Achievement.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {achievementSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function WorkExperience() {
  const {isDark} = useContext(StyleContext);
  if (achievementSection.display) {
    return (
      <div id="experience">
        <Fade bottom duration={1000} distance="20px">
          <div className="experience-container" id="workExperience">
            <div>
              <h1 className="experience-heading">Achievements and Certifcation</h1>
              <div className="experience-cards-div">
                {achievementSection.experience.map((card, i) => {
                  return (
                    <ExperienceCard
                      key={i}
                      isDark={isDark}
                      cardInfo={{
                        company: card.company,
                        desc: card.desc,
                        date: card.date,
                        companylogo: card.companylogo,
                        role: card.role,
                        descBullets: card.descBullets
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </Fade>
      </div>
    );
  }
  return null;
}


